// @ts-nocheck
/* eslint-disable */
export const docEyeIcon = {
    data: ``,
    name: 'doc-eye' as const
};